export const DEFAULT_PROJECT_SORT = "last_opened_desc";

export const PROJECT_SORT_OPTIONS = [
  { label: "Recent First", value: "updated_desc" },
  { label: "Oldest First", value: "created_asc" },
  { label: "Recently Opened", value: "last_opened_desc" },
  { label: "Name", value: "name_asc" },
];
